import { z } from 'zod';
import { ClaimFactorsSchema, ClaimNumberSchema } from '../model/index.js';
import { BaseHeaderSchema } from './base.js';
const UpdateClaimFactorsSchemas = {
    params: z.object({
        claimNumber: ClaimNumberSchema,
    }),
    body: z.object({
        claimFactors: ClaimFactorsSchema.array(),
    }),
    headers: BaseHeaderSchema,
    response: z.object({
        claimNumber: ClaimNumberSchema,
        claimFactors: ClaimFactorsSchema.array(),
    }),
};
export const UpdateClaimFactorsRequestSchema = UpdateClaimFactorsSchemas.params
    .merge(UpdateClaimFactorsSchemas.body)
    .merge(UpdateClaimFactorsSchemas.headers);
export const UpdateClaimFactorsApiSchema = UpdateClaimFactorsSchemas;
